import axiosClient from './axiosClient';
const DiemLayMauApi = {   
    updateThongTin: (data) => {
        const url = '/diemlaymau/editthongtin';
        return axiosClient.put(url, data);
    },
    addThongTin: (data) => {
        const url = '/diemlaymau/addthongtin';
        return axiosClient.post(url, data);
    },
}
export default DiemLayMauApi;